import {SEQUENCE_CREATE_TABLE_ROW} from '../_CONSTANTS';

export const sequence_Create_Table_Row = () => {
  return {
    type: SEQUENCE_CREATE_TABLE_ROW,
    payload: {}
  }
}